import { z } from 'zod';

/**
 * A search-param string. TanStack Router JSON-parses search values, so an id
 * like 4805000 or a permit number like 2401918 arrives as a number; coerce it
 * back. Leading-zero values ("02139") aren't valid JSON and stay strings.
 */
export const searchString = z.union([z.string(), z.number()]).transform(String);
